/** Admin Portal ONLY display/reporting normalization for membership amounts.
 *  ₹999 (99900) → ₹1,000 · ₹1,999 (199900) → ₹2,000 · anything else unchanged.
 *  Apply per payment BEFORE aggregation. Never used for exports, backend
 *  APIs, refunds, Razorpay, or stored values. */
export const adminDisplayMembershipAmount = (paise) => {
  const n = Number(paise);
  if (n === 99900) return 100000;
  if (n === 199900) return 200000;
  return n;
};

/** Sum of per-row normalized amounts (mirrors the Dashboard card reduce). */
export const sumAdminDisplayAmounts = (rows) =>
  rows.reduce((sum, r) => sum + (adminDisplayMembershipAmount(r.amount_paise) || 0), 0);
